module.exports = __webpack_public_path__ + "img/datetime-ar.5cc24137.png";